<template>
  <CommonHeader class="main_head_block">
    <template v-slot:header>

      <span class="module_heading" style="white-space: nowrap;width:auto;">
        Tagging Strategy     
      </span>
     
      <div class="form-group col-md-2" style="margin: 0px; padding-left: 10px">
     
      </div>

      <div class="form-group col-md-2" style="margin: 0px">
      </div>

      <div class="form-group col-md-1" style="margin: 0px">
      </div>
      
      <div>
        <div class="head_search">
          <object
            data="assets/img/search.svg"
            style="height: 18px; width: 18px; margin-left: 5px"
          ></object>
        </div>
        <div class="ghost" @click="getFilterAccountList()"></div>
		<div class="adv_fil_wrap">
          <AccountFilter style="" @getList="getList" />
        </div>
        <div class="head_search_inp">
          <input
            type="search"
            id="search"
            class="search"
            v-model="searchFilterString"
            placeholder="Client Name"
            @keyup.enter="getFilterAccountList()"
            style="border: none; outline: none; padding: 7px 0px 5px 10px"
            autocomplete="off"
          />
        </div>
      </div>

    </template>
  </CommonHeader>
</template>

<script>
import AccountFilter from "@/components/account-management/AccountFilter.vue";
import Multiselect from "vue-multiselect";
import Template from "@/components/templates/Template.vue";
import CommonHeader from "@/components/CommonHeader.vue";
export default {
  name: "TaggingStrategyHeader",
  props: ["isExportExcel"],
  components: {
    AccountFilter,
    Multiselect,
    Template,
    CommonHeader,
  },
  data() {
    return {
      selectedClientList: {},
      go_contacts_list: [
        {
          id: "go_ops",
          name: "Go_OPs",
        },
        {
          id: "go_retail",
          name: "Go_Retail",
        },
        {
          id: "go_marketing",
          name: "Go_Marketing",
        },
      ],
      selectedContactType: [],
      isTimeOut: false,
      showSpinner: false,
      isUserAdmin: this.$store.state.isUserAdmin
    };
  },
  mounted() {
    if (
      this.$store.state.selectedClientFilter &&
      this.$store.state.clientList
    ) {
      this.selectedClientList = this.$store.state.clientList.filter(
        (e) => e.client_id == this.$store.state.selectedClientFilter
      );

      if (!this.selectedClientList.length) {
        this.$store.dispatch("getAccountClient").then((resp) => {
          this.selectedClientList = this.$store.state.clientList.filter(
            (e) => e.client_id == this.$store.state.selectedClientFilter
          );
        });
      }
    } else {
      this.selectedClientList = {
        client_id: "all",
        client_name: "All Clients",
      };
    }
  },
  computed: {
    syncCount: {
      get() {
        return this.$store.getters["accounts/getSyncCount"];
      },
    },
    clientList() {
      let data = this.$store.state.clientList.filter((e) => e.client_name);
      if (data && data.length && data[0].client_id != "all")
        data.unshift({
          id: "all",
          client_name: "All Clients",
          client_id: "all",
        });
      return data;
    },
    searchFilterString: {
      set(val) {
        if (!val) {
          this.$store.state.searchFilterString = val;
          this.$emit("filterList");
        } else {
          this.$store.state.searchFilterString = val;
        }
      },
      get() {
        return this.$store.state.searchFilterString;
      },
    },
  },
  methods: {
    getFilterAccountList() {
      //sessionStorage.setItem("accounts:showPerPage",25);
      this.$store.state.currentPageNumber = 1;
      this.$emit("filterList");
    },
    getList() {
      this.$emit("filterList");
    },
    selectClient(val) {
      if (val.client_id == "all") {
        this.resetFilter();
      } else {
        this.$store.state.selectedClientFilter = val.client_id;
        this.$emit("getAccountList");
      }
    },
    resetFilter() {
      this.selectedClientList = {};
      this.$store.state.selectedClientFilter = "";
      this.$emit("getAccountList");
    },
    getContactTypeList(val) {
      let payload = {
        type: val.id,
      };
      this.$store.state.selectedAccountContactFilter = val.id;
      this.$emit("getAccountList");
    },
    resetContactFilter() {
      this.$store.state.selectedAccountContactFilter = "";
      this.selectedContactType = [];
      this.$emit("getAccountList");
    },
  },
};
</script>

<style lang="scss">
.icon-style {
  font-size: 30px;
  padding-left: 10px;
}
</style>
